import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth, API } from "@/App";
import axios from "axios";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId,
        });
        const data = res.data;
        // Store token same as regular login
        localStorage.setItem("access_token", data.access_token);
        if (setUser) {
          setUser({
            id: data.id,
            email: data.email,
            name: data.name,
            role: data.role,
            picture: data.picture,
          });
        }
        // Clear hash and navigate to dashboard
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    };

    exchangeSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="fixed inset-0 bg-gradient-hero -z-10" />
      <div className="text-center space-y-4">
        <Loader2 className="w-8 h-8 animate-spin text-cyan-400/40 mx-auto" />
        <p className="text-sm text-cyan-200/40">Signing in with Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
